import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check--circle",
  "use": "icon-check--circle-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-check--circle\"><circle cx=\"10.5\" cy=\"10\" r=\"10\" fill=\"#fff\" /><path d=\"M6.5 10.882 8.587 13 14.5 7\" stroke=\"#000\" stroke-width=\"1.29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol